var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1272148,94.9067799 C28.6563243,90.7731094 19.6600342,79.0165529 19.6600342,65.1588003 C19.6600342,38.9984366 44.726201,35.8961721 43.8906621,5 C70.4524762,20.1563818 67.0752345,45.6860116 67.0752345,45.6860116 C67.0752345,45.6860116 72.8119084,42.6832937 72.8119084,35.209857 C79.4189826,45.9571375 82.3254512,56.3274309 82.3254512,65.1588003 C82.3254512,79.1222119 73.1914529,90.9522639 60.5724127,95 C65.7739071,91.7695793 69.2372495,86.0050611 69.2372495,79.431636 C69.2372495,64.1415604 54.9980467,61.9170224 54.8693849,44.270328 C40.4598241,55.4330997 44.3812147,74.5676007 44.3812147,74.5676007 C44.3812147,74.5676007 37.1718211,72.2608809 38.1713139,61.9272307 C34.1039738,68.2087463 32.610887,74.2699223 32.610887,79.431636 C32.610887,85.9423005 36.0084117,91.6594305 41.1272148,94.9067799 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame2);
export default __webpack_public_path__ + "static/media/flame2.5b70243f7aee2ca839fdcb87ab5b0a8d.svg";
export { ForwardRef as ReactComponent };